import React from 'react'
import UserProfile from '../components/profile/UserProfile';

const ProfilePage = () => {
  return (
    <UserProfile />
  )
}

export default ProfilePage;
